var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareAStockIdea = function SvgShareAStockIdea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m16.592 10.272-2.924-.424L12.36 7.2c-.136-.272-.584-.272-.716 0l-1.308 2.652-2.924.424a.4.4 0 0 0-.324.272.4.4 0 0 0 .1.412l2.116 2.064-.5 2.912c-.024.152.036.3.16.392a.4.4 0 0 0 .42.032L12 14.98l2.616 1.376a.4.4 0 0 0 .424-.028.4.4 0 0 0 .16-.392l-.5-2.912 2.116-2.064a.4.4 0 0 0 .1-.408.4.4 0 0 0-.324-.28m-2.604 2.32a.4.4 0 0 0-.116.352l.4 2.32-2.084-1.096a.4.4 0 0 0-.376 0l-2.084 1.096.4-2.32a.39.39 0 0 0-.116-.352l-1.688-1.644 2.332-.34a.39.39 0 0 0 .3-.22L12 8.28l1.044 2.112c.06.116.172.2.3.22l2.332.34z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 15.2c-3.972 0-7.2-3.232-7.2-7.2S8.028 4.8 12 4.8c3.968 0 7.2 3.232 7.2 7.2s-3.232 7.2-7.2 7.2"
  })));
};
export default SvgShareAStockIdea;